export default __webpack_public_path__ + "static/media/lasociedad.b848802c.png";